import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { INDENTS } from 'vars/index'
import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine3Footnote5MainDefaultProps extends ITextBoxProps {}

export const TextBoxMaxLine3Footnote5MainDefault = ({
  title,
  color = Colors.BASE_MAIN_DEFAULT,
  font = TextBoxTypes.Footnote5,
  alignment = TextAligning.Left,
  maxLines = 3,
  horizontalPaddings = INDENTS.INDENT_40,
  verticalPaddings = INDENTS.INDENT_20,
  ...rest
}: ITextBoxMaxLine3Footnote5MainDefaultProps): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    maxLines={maxLines}
    horizontalPaddings={horizontalPaddings}
    verticalPaddings={verticalPaddings}
    {...rest}
  />
)
